<h1>Engagements</h1>
<div #searchSentinel class="engagements-card-list-search-sentinel"></div>
<input
  [formControl]="searchControl()"
  type="text"
  placeholder="Search"
  class="form-input form-input--search engagements-card-list-search"
  data-cy="mobile-search"
>

<div class="engagements-card-list-content">
  @if (listStatus() === LoadableStatus.LOADED) {
    @if (engagements().length === 0) {
      <div class="engagements-card-list-status-indicator">
        No records match your search.
      </div>
    } @else {
      @for (engagement of engagements(); track engagement.id) {
        <app-engagement-card-item [engagement]="engagement" (click)="cardClick.emit(engagement)" />
      }
    }
  } @else if (listStatus() === LoadableStatus.ERROR) {
    <div class="engagements-card-list-status-indicator">
      <div class="alert alert--error">
        There was an error retrieving engagement records. Please try again.
      </div>
    </div>
  } @else {
    <div class="engagements-card-list-status-indicator">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>

@if (paginationOptions().totalItems > paginationOptions().pageSize) {
  <mat-paginator
    class="engagements-card-list-paginator mb-5"
    [hidePageSize]="true"
    (page)="pageChange.emit($event)"
    [length]="paginationOptions().totalItems"
    [pageIndex]="paginationOptions().currentPage"
    [pageSize]="paginationOptions().pageSize"
    [showFirstLastButtons]="true"
  />
  <div #paginatorSentinel class="engagements-card-list-paginator-sentinel"></div>
}
